import { httpClient } from '../api/http-client';

export interface ChatMensaje {
  id: string;
  remitenteId: string;
  destinatarioId: string;
  nombreRemitente: string;
  contenido: string;
  leido: boolean;
  creadoEn: string;
}

export interface ChatUsuario {
  id: string;
  email: string;
  nombreCompleto: string;
  tipoUsuario: 'administrador' | 'miembro';
  estado: boolean;
  noLeidos: number;
  ultimoMensaje?: {
    id: string;
    remitenteId: string;
    destinatarioId: string;
    contenido: string;
    creadoEn: string;
  } | null;
}

class ChatService {
  private baseUrl = '/chat';

  private extractData<T>(response: any): T {
    return response.data.data || response.data;
  }

  async enviarMensaje(destinatarioId: string, contenido: string): Promise<ChatMensaje> {
    const response = await httpClient.post(`${this.baseUrl}/mensajes`, {
      destinatarioId,
      contenido,
    });
    return this.extractData<ChatMensaje>(response);
  }

  async obtenerConversacion(otroUsuarioId: string, limit = 100): Promise<ChatMensaje[]> {
    const response = await httpClient.get(`${this.baseUrl}/conversacion/${otroUsuarioId}?limit=${limit}`);
    return this.extractData<ChatMensaje[]>(response);
  }

  async marcarComoLeido(otroUsuarioId: string): Promise<{ leidos: number }> {
    const response = await httpClient.patch(`${this.baseUrl}/conversacion/${otroUsuarioId}/leer`, {});
    return this.extractData<{ leidos: number }>(response);
  }

  async contarNoLeidos(): Promise<{ total: number }> {
    const response = await httpClient.get(`${this.baseUrl}/no-leidos`);
    return this.extractData<{ total: number }>(response);
  }

  async obtenerUsuariosParaChat(search?: string): Promise<ChatUsuario[]> {
    const url = search?.trim()
      ? `${this.baseUrl}/usuarios?search=${encodeURIComponent(search.trim())}`
      : `${this.baseUrl}/usuarios`;
    const response = await httpClient.get(url);
    return this.extractData<ChatUsuario[]>(response);
  }
}

export const chatService = new ChatService();
